export const GIT_COMMIT_HASH_HEADER = "x-pimento-git-commit-hash";
export const CLIENT_IP_HEADER = "x-client-ip";
